import React from 'react';

/** The round "!" or "i" mark of an alert (design `.al .ic`). */
export const AlertIcon: React.FC<{ kind: 'warn' | 'info' }> = ({ kind }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
    <circle cx="12" cy="12" r="9" />
    {kind === 'warn' ? <path d="M12 7v6M12 16.5v.5" /> : <path d="M12 11v5M12 7.5v.5" />}
  </svg>
);
